import React, {useEffect, useState} from "react";
import "./Preloader.css";

const phrases = ["Загружаем приложение...", "Подготавливаем данные...", "Настраиваем интерфейс..."];

const Preloader = ({onLoaded}) => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  /* fix: убрать таймауты */
  useEffect(() => {
    const phraseInterval = setInterval(() => {
      setCurrentPhraseIndex((prevIndex) => (prevIndex + 1) % phrases.length);
    }, 2200);

    const timeout = setTimeout(() => {
      clearInterval(phraseInterval);
      onLoaded();
    }, 4000);

    return () => {
      clearInterval(phraseInterval);
      clearTimeout(timeout);
    };
  }, [onLoaded]);

  return (
    <div className="preloader">
      <div className="spinner"></div>
      <div className="preloader-text">{phrases[currentPhraseIndex]}</div>
    </div>
  );
};

export default Preloader;
